import React from 'react';

const getFaqData = (t) => {

    return [
        {
            id: 'howToPlay',
            title: t('faqs.how_to_play.title'),
            content: (
                <>
                    <div dangerouslySetInnerHTML={{ __html: t('faqs.how_to_play.content_p1') }}></div>
                    <br/>
                    <div dangerouslySetInnerHTML={{ __html: t('faqs.how_to_play.content_p2',{ sitename : process.env.REACT_APP_SITE_NAME}) }}></div>
                </>
            ),
            languages: ['en','gb', 'cy', 'nl', 'es', 'it']
        },
        {
            id: 'miniLeagues',
            title: t('faqs.mini-leagues.title'),
            content: (
                <>
                    <div dangerouslySetInnerHTML={{ __html: t('faqs.mini-leagues.content_p1') }}></div>
                    <br/>
                    <div dangerouslySetInnerHTML={{ __html: t('faqs.mini-leagues.content_p2') }}></div>
                </>
            ),
            languages: ['en','gb', 'cy', 'nl', 'es', 'it']
        },
        {
            id: 'whyRegister',
            title: t('faqs.why_register.title'),
            content: (
                <div className="section-content expanded">
                    <div dangerouslySetInnerHTML={{__html: t('faqs.why_register.content_p1')}}></div>
                    <br/>
                    <div
                        dangerouslySetInnerHTML={{__html: t('faqs.why_register.content_p2', {sitename: process.env.REACT_APP_SITE_NAME})}}></div>
                </div>
            ),
            languages: ['en','gb', 'cy', 'nl', 'es', 'it'],
        },
        {
            id: 'futurePlan',
            title: t('faqs.future_plans.title'),
            content: (
                <div className="section-content expanded">
                    <p>{t('faqs.future_plans.content_p1')}</p>
                    <ol>
                        <li>{t('faqs.future_plans.list_item_1')}</li>
                        <li>{t('faqs.future_plans.list_item_2')}</li>
                        <li>{t('faqs.future_plans.list_item_3')}</li>
                        <li>{t('faqs.future_plans.list_item_4')}</li>
                        <li>{t('faqs.future_plans.list_item_5')}</li>
                    </ol>
                    <p>{t('faqs.future_plans.contact_message', {supportEmail: process.env.REACT_APP_SUPPORT_EMAIL})}</p>
                    <p>{t('faqs.future_plans.newsletter_message', {sitename: process.env.REACT_APP_SITE_NAME})}</p>
                </div>
            ),
            languages: ['en','gb', 'cy', 'nl', 'es', 'it'],
        }
    ];
};

export default getFaqData;
